module.exports = __webpack_public_path__ + "img/myposition_dm_카세미루.8c68a4bf.png";